<template>
  <div>
    <div class="justify-content-between d-flex px-4 f-14">
      <p>เลขที่สัญญา :</p>
      <p class="f-medium">{{ displayContract }}</p>
    </div>

    <InputSelect
      valueField="code"
      textField="name"
      class="custom-select-etax"
      :options="type"
      v-model="filter.TypeCode"
      @onDataChange="handleChange"
    >
      <template v-slot:option-first>
        <b-form-select-option value="" disabled>
          เลือกประเภทเอกสาร
        </b-form-select-option>
      </template>
    </InputSelect>
    <div class="d-flex align-items-center">
      <InputSelect
        valueField="code"
        textField="name"
        class="w-50 mr-1 custom-select-etax"
        :options="monthList"
        v-model="filter.MonthCode"
        :disabled="!filter.TypeCode"
        @onDataChange="handleChange"
      >
        <template v-slot:option-first>
          <b-form-select-option value="" disabled>
            เลือกเดือน
          </b-form-select-option>
        </template></InputSelect
      >
      <InputSelect
        valueField="code"
        textField="name"
        class="w-50 ml-1 custom-select-etax"
        :options="yearList"
        v-model="filter.YearCode"
        @onDataChange="handleChange"
        :disabled="!filter.TypeCode"
      >
        <template v-slot:option-first>
          <b-form-select-option value="" disabled>
            เลือกปี
          </b-form-select-option>
        </template></InputSelect
      >
    </div>
    <div>
      <b-card v-for="(item, index) in items" :key="index" class="p-2 mt-2">
        <div class="f-14 d-flex justify-content-between">
          <div>
            <b-button class="btn-icon" @click="downLoadInvoice(item)">
              <img
                :src="require('@/assets/images/Icon/icon_pdf.png')"
                class="icon-w mb-1 mr-1"
              />
            </b-button>
            {{ item.fileName }}
          </div>

          <font-awesome-icon
            class="icon-w f-orange"
            :icon="['fas', 'download']"
            @click="downLoadInvoice(item)"
          />
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect.vue";

export default {
  components: { InputSelect },
  props: {
    lineProfile: {
      required: false,
      type: Object
    },
    contractNo: {
      required: false,
      type: String
    },
    displayContract: {
      required: false,
      type: String
    }
  },
  data: () => {
    return {
      isBusy: false,
      items: [],
      profile: {},
      type: [],
      yearList: [],
      monthList: [],
      filter: {
        TypeCode: "",
        MonthCode: "",
        YearCode: "",
        LineId: "",
        ContractNo: ""
      }
    };
  },
  created() {},
  methods: {
    async getFilter() {
      this.filter = {
        TypeCode: this.filter.TypeCode || "",
        MonthCode: this.filter.MonthCode || "",
        YearCode: this.filter.YearCode || "",
        LineId: this.lineProfile.userId,
        ContractNo: this.contractNo
      };
      this.items = [];

      this.isBusy = true;
      var myHeaders = new Headers();
      myHeaders.append("API-KEY", this.$API_KEY_DEV_LINE_SKL);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        LineId: this.lineProfile.userId,
        ContractNo: this.contractNo,
        TypeCode: this.filter.TypeCode
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: raw
      };

      await fetch(
        `${this.$API_DEV_LINE_SKL}/contract/GetReceiptFilter`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          if (result.result == 1) {
            this.monthList = result.detail.month.map(x => ({
              ...x,
              disabled: x.isActive ? false : true
            }));
            this.yearList = result.detail.year.map(x => ({
              ...x,
              disabled: x.isActive ? false : true
            }));
            this.type = result.detail.type.map(x => ({
              ...x,
              disabled: x.isActive ? false : true
            }));
            this.profile.contractNo = result.detail.contractNo;
            this.isBusy = false;
          } else {
            this.isBusy = false;
            this.items = [];
          }
        })
        .catch(error => {
          this.isBusy = false;
          this.items = [];
          console.error(error);
        });
      this.$isLoadingAlpha = false;
    },
    async handleChange() {
      if (this.filter.TypeCode) {
        await this.getFilter();
      }

      if (
        this.filter.TypeCode &&
        this.filter.MonthCode &&
        this.filter.YearCode
      ) {
        await this.getList();
      }
    },
    async getList() {
      this.isBusy = true;

      var myHeaders = new Headers();
      myHeaders.append("API-KEY", this.$API_KEY_DEV_LINE_SKL);
      myHeaders.append("Content-Type", "application/json");

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: JSON.stringify({ ...this.filter })
      };

      await fetch(
        `${this.$API_DEV_LINE_SKL}/contract/GetReceipt`,
        requestOptions
      )
        .then(response => response.json())
        .then(result => {
          if (result.result == 1) {
            this.items = result.detail.detail;
            this.isBusy = false;
          }
        })
        .catch(error => {
          this.isBusy = false;
          this.items = [];
          console.error(error);
        });
    },
    async downLoadInvoice(item) {
      const fileUrl = item.filePath;

      const link = document.createElement("a");
      link.href = fileUrl;

      const paymentDate = item.fileName.replace(/\//g, "-");
      link.download = `Invoice_${paymentDate}.pdf`;

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      var myHeaders = new Headers();
      myHeaders.append("API-KEY", this.$API_KEY_DEV_LINE_SKL);
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        LineId: this.lineProfile.userId,
        ContractNo: this.contractNo,
        TypeCode: this.filter.TypeCode,
        FileTypeCode: this.filter.TypeCode,
        FileName: item.fileName,
        FilePath: item.filePath,
        FileDate : item.fileDate
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: raw
      };

      const res = await fetch(
        `${this.$API_DEV_LINE_SKL}/ReportReceipt`,
        requestOptions
      );
    }
  }
};
</script>

<style scoped>
.txt-note {
  font-size: 12px;
}
.display-inline {
  display: inline-flex;
}

::v-deep .card-body {
  padding: 0 !important;
}

.icon-w {
  width: 20px;
  height: 20px;
}
.custom-select-etax ::v-deep .custom-select {
  text-align: center !important;
  border: none;
  border-width: thin;
  border-color: #80c141;
  background-color: #e4f4d9;
  border-radius: 16px;
  color: #676767;
}

.custom-select-etax ::v-deep select option:disabled {
  color: #aaa;
}

.btn-icon {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  box-shadow: none !important;
}

.btn-icon:hover,
.btn-icon:focus,
.btn-icon:active {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
</style>
